"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersExportHighchartsButton = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const AppPubSub_1 = require("src/hello_assets/src/util/PubSub/AppPubSub");
const HighchartsWithOptionsComponent_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsWithOptionsComponent");
const lodash_1 = __importDefault(require("lodash"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const ActiveUsersPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/ActiveUsersPageDataProvider");
const ActiveUsersHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/state/data/ActiveUsersHighchartsComponent");
const antd_1 = require("antd");
const use_custom_compare_1 = require("use-custom-compare");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const CSVUtil_1 = require("src/hello_assets/src/util/CSVUtil");
const Action_Export_CSV = "csv";
exports.ActiveUsersExportHighchartsButton = React.memo(() => {
    const { state: { status, error, data }, stateFns } = (0, ActiveUsersPageDataProvider_1.useActiveUsersPageDataContext)();
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const disabled = status.inProgress || highchartsOptionsContext.state.error.isError || lodash_1.default.isNil(data);
    const jsonModel = stateFns.getURLJSONModel();
    const aggregation = jsonModel.getAggregationJSONModel().getAggregation();
    const onClickExportHighcharts = (0, react_1.useCallback)(() => {
        AppPubSub_1.AppPubSub.publish(HighchartsWithOptionsComponent_1.PubSubAction_ExportHighcharts, { chartIdentifier: ActiveUsersHighchartsComponent_1.activeUsersChartIdentifier });
    }, []);
    const onClickMenu = (0, use_custom_compare_1.useCustomCompareCallback)((menuInfo) => {
        if (menuInfo.key === Action_Export_CSV) {
            const exportResult = ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getActiveUsersCSV(data, { aggregation: aggregation });
            if (exportResult) {
                CSVUtil_1.CSVUtil.prepareAndDownload(exportResult.data, { headers: ["timeMillis", "activeUsers"] }, { title: exportResult.title });
            }
        }
    }, [data, aggregation], lodash_1.default.isEqual);
    const menu = React.createElement(antd_1.Menu, { onClick: onClickMenu, items: [{
                key: Action_Export_CSV,
                label: "Export CSV",
                disabled: disabled
            }] });
    return React.createElement(antd_1.Dropdown.Button, { onClick: onClickExportHighcharts, disabled: disabled, overlay: menu, trigger: ["click"] }, "Export");
});
